{
  "commonHeader": {
    "upgradeToPro": "升級",
    "learnMore": "深入瞭解",
    "AIProductivitySuite": {
      "title": "AI 生產力套件",
      "desc": "將充滿靈感的討論轉化為令人印象深刻的成果。"
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "使用 AI 管理組織帳戶",
        "description": "取得帳戶問題的智慧解答，並協助您瀏覽設定。",
        "terms": "使用 Zoom 測試版功能，即表示您同意 {0}",
        "termsText": "Zoom 測試版計畫條款"
      },
      "diveDeeper": "深入瞭解",
      "shareFeedback": "在 {0} 中分享意見",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "詢問有關貴組織帳戶的問題",
      "heroInvite": "如何邀請新使用者加入我的帳戶？",
      "heroGroups": "如何將使用者指派到群組？",
      "heroRoles": "如何管理角色和權限？"
    },
    "backMainAccount": "返回主帳戶",
    "discoverProducts": "探索產品",
    "pricing": "定價",
    "more": "更多",
    "sidebarExpanded": "已展開",
    "sidebarCollapsed": "已收合",
    "search": "搜尋",
    "users": "使用者",
    "settings": "帳戶設定",
    "navigation": "導覽",
    "clear": "清除",
    "searchPlaceholderAll": "搜尋使用者、帳戶設定或導覽",
    "searchPlaceholderUsers": "搜尋使用者或導覽",
    "searchPlaceholderSettings": "搜尋帳戶設定或導覽",
    "searchPlaceholderNav": "搜尋導覽",
    "searchGuide": "輸入關鍵字開始搜尋",
    "installOnDesktop": "安裝到桌面",
    "downloadCenter": "下載中心",
    "getInTouch": "與我們聯絡",
    "featuredProduct": "精選產品",
    "logo": {
      "adminCenter": "管理中心",
      "subAccount": "正在管理子帳戶",
      "externalAccount": "正在管理委派帳戶"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "深入瞭解",
      "gotIt": "瞭解"
    },
    "coachMark": {
      "dvsTipsTitle": "分區現已可用",
      "dvsTipsContent": "分區用於在您的帳戶內建立某些 Zoom 產品的多個執行個體。"
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "深入瞭解",
      "gotIt": "瞭解"
    },
    "coachMark": {
      "extAccountTipsTitle": "管理外部帳戶",
      "extAccountTipsContent": "需要管理其他帳戶？只要傳送請求——對方核准後，即可開始管理！"
    }
  },
  "feedback": {
    "dialogTitle": "提供意見反應",
    "itemLableForProductArea": "產品領域",
    "itemLableForSatisfied": "您對體驗的滿意度如何？",
    "dissatisfied": "非常不滿意",
    "satisfied": "非常滿意",
    "itemLableForFeedback": "意見反應",
    "placeholder": "感謝您提供的想法、意見與建議。",
    "btnCancel": "取消",
    "btnSubmit": "提交",
    "supportTips": "如需技術支援，請造訪",
    "btnSupport": "支援。",
    "messages": {
      "success": "感謝您的意見反應！",
      "productFailed": "需要產品領域。",
      "scoreFailed": "需要滿意度分數。"
    },
    "products": {
      "General": "一般",
      "AI": "AI",
      "Apps": "應用程式",
      "Calendar": "行事曆",
      "Clips": "Clips",
      "ContactCenter": "聯絡中心",
      "Docs": "文件",
      "Huddles": "Huddles",
      "Mail": "郵件",
      "Meetings": "會議",
      "Notes": "筆記",
      "Phone": "電話",
      "Revenue": "Revenue",
      "Rooms": "會議室",
      "Scheduler": "預約助手",
      "Tasks": "工作",
      "TeamChat": "團隊聊天",
      "WebinarsAndEvents": "網路研討會與活動",
      "Whiteboard": "白板",
      "WorkflowAutomations": "工作流程自動化",
      "WorkspaceReservation": "工作空間預約",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "此份免責聲明是由您的帳戶管理員所產生。",
    "cancel": "取消",
    "agree": "同意"
  },
  "shared": {
    "sideMenu": {
      "personal": "個人",
      "admin": "管理員",
      "menu": "選單",
      "pinned": "已釘選",
      "pin": "釘選",
      "unpin": "取消釘選",
      "moveItem": "移動項目",
      "myAccount": "我的帳戶",
      "upgradeToPro": "升級至專業版",
      "grabbedKeyboard": "已抓取 {0}。使用上下箭頭鍵移動，按空格或 Enter 放下。",
      "dropped": "已放下 {0}。",
      "releasedUnchanged": "已釋放 {0}，位置未變更。",
      "movedToPosition": "{0} 已移至第 {1} 位，共 {2} 項。",
      "movedUp": "{0} 已上移，目前位置第 {1} 位，共 {2} 項。",
      "movedDown": "{0} 已下移，目前位置第 {1} 位，共 {2} 項。",
      "movedUpNew": "{0} 已上移，新位置第 {1} 位，共 {2} 項",
      "movedDownNew": "{0} 已下移，新位置第 {1} 位，共 {2} 項",
      "cannotMoveFurther": "{0} 無法再移動。",
      "grabbedMouse": "已抓取 {0}。移動滑鼠以重新定位，按一下放下，按 Esc 取消。"
    },
    "item": "項目",
    "gotIt": "瞭解",
    "adminCenterGuide": {
      "title": "歡迎使用全新管理中心",
      "content": "<p class=\"mgb-xs\">精簡的中心，助你隨時掌握資訊並保持掌控。</p><p>管理中心將重要更新、工作和工具集中在一起，方便你設定產品、追蹤請求，並處理最重要的事項。</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "電話號碼新增成功！您現在可以使用此號碼進行未來的登入與帳戶恢復。",
    "mfa_to_signin_phone_success": "{phone} 現已成為 {email} 的登入電話號碼。",
    "login_passkey_bound_success": "已成功建立通行金鑰"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "下列進階管理功能將僅適用於授權使用者和協作使用者",
      "licensed_basic": "下列進階管理功能將僅適用於授權使用者和基本版使用者",
      "licensed": "下列進階管理功能將僅適用於授權使用者"
    },
    "support": "- 在帳戶設定和使用者群組設定中受支援",
    "archive_product": {
      "title": "封存會議與網路研討會",
      "detail": "- 當您帳戶的使用者加入時，會議將會被封存。若要使用此設定，從Zoom App Marketplace安裝<a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">封存應用程式</a>。"
    },
    "restrict": {
      "title": "限制使用者在加入會議時使用選取的功能",
      "detail": "- 即便會議主持人為會議啟用了所選功能，這些功能也無法使用。"
    },
    "meeting_integration": {
      "title": "啟用會議中聊天DLP（資料外洩防護）整合",
      "detail": "- 啟用後，DLP將同時適用於與會者所傳送的公開與私人聊天訊息。如果（內部/外部）會議與會者正在聊天，而某一則訊息違反了主持人所屬組織的合規性政策，則會立即刪除該訊息。"
    },
    "chat_tool": {
      "title": "聊天禮儀工具",
      "detail": "- 識別分享內容中的定義關鍵字及文字模式，並防止使用者分享不適當的訊息"
    },
    "information_barriers": {
      "title": "資訊屏障",
      "detail": "- 資訊屏障可管控部分使用者之間的通訊以符合合規目的。可以禁止兩個群組使用者之間進行開會及聊天，也可禁止部分使用者使用特定功能（如會議中聊天、畫面分享及檔案傳送）。這些限制可防止未經授權使用者彼此之間交換機密資訊。"
    },
    "dashboard": {
      "title": "儀表板",
      "detail": "- 針對會議>過往會議儀表板，某些使用者僅能顯示3個月的資料"
    },
    "reports": {
      "title": "報告",
      "detail": "- 部分使用者報告僅顯示某些使用者3個月的資料：免責聲明報告、觀眾記錄報告、管理員活動記錄報告，以及登入/登出報告"
    },
    "close": "關閉"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "您的{planName}將於{cancelDate}取消。在該日期之前，您可以重新啟動您的網路研討會授權。從{supportStartDate}—{supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會資料。{dataLossDate}後，您將失去所有網路研討會的資料。",
            "nonAdmin": "您的{planName}將於{cancelDate}取消。在此日期之前，您可以聯絡帳戶管理員以重新啟動網路研討會授權。從{supportStartDate}—{supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會資料。在{dataLossDate}後，您將失去帳戶中所有網路研討會的資料。"
          },
          "admin": "您的{planName}將於{cancelDate}取消。在該日期之前，您可以重新啟用您的網路研討會授權。從{supportStartDate}—{supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會{supportContent}。在{dataLossDate}後，您將失去帳戶中所有網路研討會的資料。",
          "nonAdmin": "您的{planName}將於{cancelDate}取消。在此日期之前，您可以聯絡帳戶管理員以重新啟動您的網路研討會授權。從 {supportStartDate}—{supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會{supportContent}。在{dataLossDate}後，您將失去帳戶中所有網路研討會的資料。"
        },
        "expired": {
          "admin": "您的{planName}已取消。從{supportStartDate}—{supportEndDate}，您可以聯絡客戶支援取得現有的網路研討會{supportContent}，或再次購買Zoom Webinars以恢復資料存取權限。在{dataLossDate}之後，您將失去帳戶中所有網路研討會的資料。",
          "nonAdmin": "您的{planName}已取消。從{supportStartDate}—{supportEndDate}，您可以聯絡客戶支援取得現有的網路研討會{supportContent}，或聯絡帳戶管理員再次購買Zoom Webinars以恢復資料存取權限。在{dataLossDate}後，您將失去帳戶中所有網路研討會的資料。"
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "您的{planName}將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視現有的網路研討會及其資產。您可以隨時取消暫停並恢復訂閱網路研討會授權。",
            "nonAdmin": "您的{planName}將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視現有的網路研討會及其資產。您可以隨時聯絡帳戶管理員，移除暫停並恢復網路研討會授權的訂閱。"
          },
          "admin": "您的{planName}將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視{supportContent}。您可以隨時取消暫停並恢復訂閱您的網路研討會授權。",
          "nonAdmin": "您的{planName}將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視{supportContent}。您可以隨時聯絡帳戶管理員，移除暫停並恢復網路研討會授權的訂閱。"
        },
        "active": {
          "webinars": {
            "admin": "您的{planName}已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會。歡迎隨時恢復您的網路研討會授權訂閱。",
            "nonAdmin": "您的{planName}已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會。您可以隨時聯絡帳戶管理員，恢復網路研討會授權的訂閱。"
          },
          "admin": "您的{planName}已暫停{pauseDuration}。在暫停期間，您只能檢視現有的網路研討會{supportContent}。歡迎隨時恢復您的網路研討會授權訂閱。",
          "nonAdmin": "您的{planName}已暫停{pauseDuration}。在暫停期間，您只能檢視現有的網路研討會{supportContent}。您可以隨時聯絡帳戶管理員，恢復網路研討會授權的訂閱。"
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "您的{planName}授權將在{pausedDate}暫停{pauseDuration}。若要繼續主持網路研討會，請在暫停生效前為此使用者指派有效授權。您也可以移除暫停，以繼續使用此授權。",
            "nonAdmin": "您的{planName}授權將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視現有的網路研討會及其資產。若要繼續主持網路研討會，請在暫停生效前聯絡您的帳戶管理員，為您的帳戶指派有效授權。"
          },
          "active": {
            "admin": "您的{planName}授權已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會。歡迎隨時恢復授權訂閱，或指派有效授權至您的帳戶以繼續主持網路研討會。",
            "nonAdmin": "您的{planName}授權已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會。若要在暫停期間主持網路研討會，請聯絡您的帳戶管理員，為您的帳戶指派有效授權。"
          }
        },
        "cancel": {
          "active": {
            "admin": "您的{planName}授權將於{cancelDate}取消。若要繼續主持網路研討會，請在取消生效前重新啟用您的網路研討會授權或指派有效授權。若未採取任何動作，您在{supportStartDate} - {supportEndDate}期間將有寬限期，可聯絡客戶支援以擷取現有的網路研討會資料。在{dataLossDate}之後，與您的帳戶關聯的所有網路研討會資料將永久刪除。",
            "nonAdmin": "您的{planName}授權將於{cancelDate}取消。若要繼續主持網路研討會，請在取消生效前聯絡您的帳戶管理員以重新啟用網路研討會授權，或是指派有效授權。如果未採取任何行動，您將在{supportStartDate} - {supportEndDate}期間享有寬限期，可聯絡客戶支援以擷取現有的網路研討會資料。在{dataLossDate}之後，與您帳戶關聯的所有網路研討會資料將永久刪除。"
          },
          "expired": {
            "admin": "您的{planName}授權已取消。若要繼續主持網路研討會，請指派有效授權給此使用者。從{supportStartDate} - {supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會資料。",
            "nonAdmin": "您的{planName}授權已遭取消。若要繼續主持網路研討會，請聯絡您的帳戶管理員，為您的設定檔指派有效授權。從{supportStartDate}—{supportEndDate}，請聯絡客戶支援以取得現有的網路研討會資料。"
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "您的{planName}授權將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視先前網路研討會的{supportContent}。若要繼續存取網路研討會資產，請在暫停生效前指派有效授權給此使用者。您也可以移除暫停以繼續使用此授權。",
              "nonAdmin": "您的{planName}授權將在{pausedDate}暫停{pauseDuration}。在暫停期間，您只能檢視{supportContent}。若要繼續存取網路研討會資產，請聯絡您的帳戶管理員，將有效授權指派給您的設定檔。"
            },
            "active": {
              "admin": "您的{planName}已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會{supportContent}。若要繼續存取網路研討會資產，請為您的帳戶指派有效授權。您也可以隨時恢復此授權訂閱。",
              "nonAdmin": "您的{planName}已暫停{pauseDuration}，將從{pausedDate}開始。在暫停期間，您只能檢視現有的網路研討會{supportContent}。如要在暫停期間主持網路研討會，請聯絡您的帳戶管理員，為您的帳戶指派有效授權。"
            }
          },
          "cancel": {
            "active": {
              "admin": "您的{planName}將於{cancelDate}取消。若要繼續主持網路研討會，請在取消生效前將有效授權指派給您的帳戶。您可以在{cancelDate}之前重新啟用此授權。從{supportStartDate} - {supportEndDate}，您可以聯絡客戶支援以取得現有的網路研討會{supportContent}。",
              "nonAdmin": "您的{planName}授權將於{cancelDate}取消。若要繼續主持網路研討會，請在取消生效前聯絡帳戶管理員重新啟用網路研討會授權或指派有效授權。如果未採取任何操作，您將有一個寬限期（{supportStartDate}至{supportEndDate}），可聯絡客戶支援取得現有網路研討會的{supportContent}。{dataLossDate}之後，與您帳戶相關聯的所有網路研討會資料將被永久刪除。"
            },
            "expired": {
              "admin": "您的{planName}授權已取消。若要繼續主持網路研討會，請為此使用者指派有效授權。從{supportStartDate}到{supportEndDate}，請聯絡客戶支援以取得現有的網路研討會{supportContent}。",
              "nonAdmin": "您的{planName}授權已取消。若要繼續主持網路研討會，請聯絡您的帳戶管理員，為您的設定檔指派有效授權。從{supportStartDate}到{supportEndDate}，聯絡客戶支援以取得現有網路研討會的{supportContent}。"
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "資料",
        "recordingsAndTranscripts": "錄製檔案及轉錄文字",
        "reports": "報告",
        "summaries": "摘要",
        "dashboard": "儀表板"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "先前網路研討會的錄製檔案和轉錄文字",
          "reports": "先前網路研討會的報告",
          "summaries": "先前網路研討會摘要",
          "dashboard": "先前網路研討會儀表板",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "重新啟用方案",
    "purchasePlan": "購買方案",
    "removePause": "移除暫停",
    "resumeSubscription": "恢復訂閱",
    "month": "月",
    "months": "個月",
    "assignLicense": "指派授權"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "瞭解"
    },
    "coachMark": {
      "tipsTitle": "通訊錄將更名為客戶目錄",
      "tipsContent": "在 2026 年 10 月的版本中，我們將「通訊錄」更名為「客戶目錄」，以更準確地反映其用途。所有現有功能、權限和工作流程將保持不變——您仍可像現在一樣管理客戶清單（通訊錄）和聯絡人。"
    }
  },
  "zoomPrivacy": {
    "agreeMain": "我們正在更新條款和政策",
    "agreeSub": "一旦您繼續使用 Zoom，即表示您已接受更新的<a href=\"https://www.zoom.us/terms\" target=\"_blank\">服務條款</a>和<a href=\"https://www.zoom.us/privacy\" target=\"_blank\">隱私權政策</a>。",
    "continue": "繼續"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "返回主帳戶",
      "backLinkedAccount": "返回連結帳戶",
      "backMyAccount": "返回我的帳戶",
      "myAccount": "我的帳戶"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "自訂 AI 伴侶現已可用於您的帳戶",
      "desc": "以下是您可以在帳戶中使用的部分自訂 AI 伴侶功能：",
      "studioTitle": "AI Studio",
      "studioDesc": "為您的組織自訂 AI 伴侶體驗。",
      "integrationsTitle": "第三方整合",
      "integrationsDesc": "運用第三方應用程式簡化工作流程。",
      "clipsTitle": "Zoom Clips 自訂虛擬形象",
      "clipsDesc": "允許使用者個人化 AI 虛擬形象，以便在剪輯中使用。"
    },
    "coachMark": {
      "licenseTitle": "您有 {0} 個自訂 AI 伴侶授權待指派",
      "licenseDesc": "請在<b>使用者管理</b>下指派這些授權，以便使用者開始使用進階 AI 伴侶功能。",
      "settingTitle": "查看帳戶的自訂 AI 伴侶設定",
      "settingDesc": "在<b>帳戶設定</b>下為每項自訂 AI 功能設定選項。<a href=\"/account/setting?tab=aicompanion\">前往設定</a>",
      "groupSettingTitle": "查看群組的自訂 AI 設定",
      "groupSettingDesc": "在<b>群組設定</b>下為每項自訂 AI 功能設定選項。<a href=\"/account/group\">前往設定</a>"
    },
    "common": {
      "learnMore": "深入瞭解",
      "quickTour": "快速導覽",
      "remindLater": "稍後再提醒我",
      "dismiss": "關閉",
      "next": "下一步",
      "back": "返回",
      "gotIt": "瞭解",
      "goToSetting": "前往設定"
    },
    "aiPanelToast": "開啟<b>Zoom Workplace 中的 AI 面板</b>設定，開始使用全部自訂 AI 伴侶功能。"
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "瞭解",
      "next": "下一步",
      "remindMeLater": "稍後再提醒我",
      "waffleMenuTitle": "歡迎使用全新 Zoom 網頁體驗",
      "waffleMenuDesc": "透過全新的<b>產品選單</b>，隨時隨地存取 Zoom 產品。",
      "profileMenuTitle": "我的帳戶",
      "profileMenuDesc": "在<b>我的帳戶</b>中找到您的個人資料和個人設定。",
      "personalTitle": "取得您所需的一切",
      "personalDesc": "<b>我的帳戶</b>包含您的個人資料、設定、會議轉錄文字等。",
      "adminCenterTitle": "在管理中心尋找組織設定",
      "adminCenterDesc": "全新<b>管理中心</b>可讓您為整個組織設定產品並調整設定。",
      "adminMenuForTitle": "像專業人士一樣使用管理中心",
      "adminMenuForAccountSettings": "<b>設定</b>可讓您存取組織中所有人的預設產品設定。",
      "adminMenuForContentManagementItem": "您可以在<b>內容管理</b>中管理所有使用者產生的內容。",
      "adminMenuForConfigureProductsItem": "<b>產品設定</b>可讓您為產品完成設定和管理員工作。",
      "adminMenuForNoItems": "全新管理中心可讓您更輕鬆地存取和管理帳戶設定與產品。您也可以將常用項目釘選，以便更快存取。",
      "tryNewExperience": "試用新體驗",
      "tryNewExperienceDetail": "試試看！您隨時可以返回此經典體驗。",
      "tryNewExperienceTitle": "Zoom 網頁版全新外觀！"
    }
  },
  "footerCopyright": {
    "copyright": "著作權 {'@'}{0} Zoom Communications, Inc. 保留所有權利。",
    "terms": "條款",
    "privacy": "隱私權",
    "trust_center": "信任中心",
    "acceptable_use_guidelines": "可接受使用準則",
    "legal": "法律",
    "do_not_sell_my_personal_information": "您的隱私權選擇",
    "cookie_preferences": "Cookie 偏好設定",
    "pricing": "方案與定價",
    "feedback": "意見反應",
    "contact_us": "與我們聯絡"
  },
  "termChange": {
    "changeTerm": {
      "title": "續約期限變更協議",
      "quoteNumbers": "已修改的訂購單 - {0}",
      "content1": "接受本條款即表示客戶同意修改 Zoom Communications, Inc.（「Zoom」）與客戶之間所有訂購單的現有訂閱續約期限，將承諾期限從按月續約期限變更為{0}。作為該承諾的對價，Zoom 同意在第一個新續約期限內維持客戶的目前定價。",
      "content2": "客戶理解，一旦客戶點選下方「我接受」，新的續約期限 {0} 即告適用，且該新續約期限將於客戶目前按月續約期限結束後的次日開始。此新續約期限將適用於目前與 Zoom 有效的所有訂購單，且這些訂購單項下所有未來續約期限均採用相同的續約期限長度。",
      "content3": "客戶確認，本次僅變更續約期限，目前與 Zoom 有效的每份訂購單的所有其他條款和條件均保持不變，並按其條款繼續完全有效。",
      "content4": "您進一步同意，此為客戶與 Zoom 之間的合約承諾。",
      "agreementText": "點選「我接受」，即表示您證明自己有權代表客戶作出此項變更，且客戶同意上述條款和條件。",
      "IDecline": "我拒絕",
      "IAccept": "我接受"
    },
    "unableToChangeTerm": {
      "title": "無法變更續約期限",
      "content": "您的帳戶不符合更新續約期限的條件。如果這是錯誤，請<a target=\"_blank\" href=\"{0}\">與我們聯絡</a>。",
      "acceptedTitle": "續約期限已延長",
      "acceptedContent": "您先前已接受續約條款，無需再採取任何操作。",
      "GotIt": "瞭解"
    },
    "termLengthUpdated": "續約期限長度已更新為 {0} 個月。",
    "termLengthUnchanged": "期限長度未變更。",
    "errorInfo": "發生伺服器錯誤。請再試一次。",
    "x12MonthTerm": "十二（12）個月期限",
    "x24MonthTerm": "二十四（24）個月期限",
    "x12MonthTermPlural": "十二（12）個月",
    "x24MonthTermPlural": "二十四（24）個月"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "你的帳戶預計於 {0} 更新至<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">全新 Zoom 網頁體驗</a>。",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">查看更新時間</a>"
    },
    "completed": {
      "content": "全新 Zoom 網頁體驗現已對帳戶中的所有使用者生效。使用者下次登入時將看到更新後的介面。"
    }
  }
}
